export const ATO_QUALIFYING_EARNINGS_URL =
  'https://www.ato.gov.au/businesses-and-organisations/super-for-employers/payday-super/paying-super-on-payday/what-payments-are-qualifying-earnings#ato-Whatarequalifyingearnings';

export const RECKON_QUALIFYING_EARNINGS_HELP_URL =
  'https://help.reckon.com/article/u5emlpkppo-update-pay-items-to-report-qualifying-earnings-for-payday-super';
